// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"b5527a1b","277":"4413d1bd","346":"92bc71ec","697":"278a77dc"}[chunkId] + ".chunk.js";
};